import be_A_Pong from "../../image/gameicon/Be_a_pong.jpg";
import gentle_Sniper from "../../image/gameicon/Gentle_Sniper.jpg";
import sneak_Out from "../../image/gameicon/Sneak_Out_3D.jpg";
import wacky_Jelly from "../../image/gameicon/Wacky_Jelly.jpg";
import agentTwist from "../../image/gamelist/Icon_Agent_Twist_1024.jpg";
import antsAndMantis from "../../image/gamelist/ant.jpg";
import cafeMaster from "../../image/gamelist/cafeMaster.jpg";
import changeAndDrop from "../../image/gamelist/change.jpg";
import changeTheBody from "../../image/gamelist/changeTheBody.jpg";
import dartPop from "../../image/gamelist/dartDrop.jpg";
import decalcomanieGallery from "../../image/gamelist/DecalcomanieGallery.jpg";
import dominoVilage from "../../image/gamelist/dominoVilage.jpg";
import dumbTurtle from "../../image/gamelist/dumbTurtle.jpg";
import eggDrop from "../../image/gamelist/eggDrop.jpg";
import fillUpRun from "../../image/gamelist/fillUpRun.jpg";
import findAlien from "../../image/gamelist/findAlien.jpg";
import findFive from "../../image/gamelist/findFive.jpg";
import fireworksCastle from "../../image/gamelist/fireworksCastle.jpg";
import flatCube from "../../image/gamelist/flatCube.jpg";
import gravityRush from "../../image/gamelist/gravityRush.jpg";
import herosRun from "../../image/gamelist/herosrun.jpg";
import hydroDipping from "../../image/gamelist/hydroDipping.jpg";
import idleLandMark from "../../image/gamelist/idleLandMark.jpg";
import iqAndR from "../../image/gamelist/IQAndR.jpg";
import justMaze from "../../image/gamelist/justMaze.jpg";
import killTheBug from "../../image/gamelist/killTheBug.jpg";
import lifeOfMellow from "../../image/gamelist/lifeOfMellow.jpg";
import lightUpMyHouse from "../../image/gamelist/lightUpMyHouse.jpg";
import litIt from "../../image/gamelist/litIt.jpg";
import myFoodTruck from "../../image/gamelist/myFoodTruck.jpg";
import numberRun from "../../image/gamelist/numberRun.jpg";
import orbitIo from "../../image/gamelist/orbit.Io.jpg";
import perfectChallenge from "../../image/gamelist/perfectChallenge.jpg";
import prankStarz from "../../image/gamelist/prankStarz.jpg";
import rescueBoat from "../../image/gamelist/rescueBoat.jpg";
import rollingQueen from "../../image/gamelist/rollingQueen.jpg";
import roomsNLooter from "../../image/gamelist/roomsNLooter.jpg";
import shootingColor from "../../image/gamelist/shootingColor.jpg";
import snapShot from "../../image/gamelist/snapShot.jpg";
import spaceCore from "../../image/gamelist/spaceCore.jpg";
import splashJump from "../../image/gamelist/splashJump.jpg";
import stackCube from "../../image/gamelist/stackCube.jpg";
import stackRunway from "../../image/gamelist/stackRunway.jpg";
import stackRush from "../../image/gamelist/stackRush.jpg";
import swordHero from "../../image/gamelist/swordHero.jpg";
import timeStopper from "../../image/gamelist/timeStopper.jpg";
import timeWalker from "../../image/gamelist/timeWalker.jpg";
import tinyRun from "../../image/gamelist/tinyRun_home.jpg";
import trampolineKing from "../../image/gamelist/trampolineKing.jpg";
import washHouse from "../../image/gamelist/washHouse.jpg";
import whichIsWhich from "../../image/gamelist/whichIsWhich.jpg";
import zScavenger from "../../image/gamelist/ZScavenger.jpg";
import fishOutOfWater from "../../image/gamelist/Fish out of Water 3D.png";
import bombBrothers from "../../image/gamelist/Bomb brothers icon.png";
import cutThePaper from "../../image/gamelist/icon_cutthepaper.png";
import flightIO from "../../image/gamelist/icon_flightio.png";
import slideBalls from "../../image/gamelist/icon_slideballs.png";
import tankBalls from "../../image/gamelist/tankball.png";
import vehicleMaster from "../../image/gamelist/vehiclemaster.png";
import PlanetHunter3D from "../../image/gamelist/planetHunter3D.png";
import spotIt from "../../image/gamelist/spotIt.png";
import punchBattle from "../../image/gamelist/punchBattle.png";
import shotAndFit from "../../image/gamelist/ShootAndFit_Icon.png";
import rainbowBlock from "../../image/gamelist/RainbowBlocks_Icon.png";
import wantedFish from "../../image/gamelist/wantedFish.png";

import castleGuardians from "../../image/gamelist/Castle_Guardians_3D_Master.png";
import loveFlag from "../../image/gamelist/Love_Flag.png";
import saveTheGrandMother from "../../image/gamelist/Save the Grandmother.png";
export let gameList = [
  {
    id: 68,
    title: "Save the grandmother",
    appleUrl: "https://apps.apple.com/us/app/save-the-grandmother/id1614982497",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.grandmother",
    icon: saveTheGrandMother,
  },
  {
    id: 67,
    title: "Love Flag",
    appleUrl: "https://apps.apple.com/us/app/love-flag/id1604695713",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.swiperight",
    icon: loveFlag,
  },
  {
    id: 66,
    title: "Castle Guardians 3D",
    appleUrl: "https://apps.apple.com/us/app/castle-guardians-3d/id1612010180",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.castle",
    icon: castleGuardians,
  },
  {
    id: 65,
    title: "Wanted Fish",
    appleUrl: "https://apps.apple.com/us/app/wanted-fish/id1606318335",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.wantedfish",
    icon: wantedFish,
  },
  {
    id: 64,
    title: "Rainbow Block 3D",
    appleUrl: "https://apps.apple.com/us/app/rainbow-block-3d/id1613659818",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.rainbow",
    icon: rainbowBlock,
  },
  {
    id: 63,
    title: "Shoot and Fit",
    appleUrl: "https://apps.apple.com/us/app/shoot-and-fit/id1597691904",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.shootandfit",
    icon: shotAndFit,
  },
  {
    id: 62,
    title: "Punch Battle 3D",
    appleUrl: "https://apps.apple.com/us/app/punch-battle-3d/id1611673301",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.punch",
    icon: punchBattle,
  },
  {
    id: 61,
    title: "Planet Hunter 3D",
    appleUrl: "https://apps.apple.com/us/app/planet-hunter-3d/id1607206945",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.hunter",
    icon: PlanetHunter3D,
  },
  {
    id: 60,
    title: "Spot it : diffrent trip",
    appleUrl: "https://apps.apple.com/us/app/vehicle-master/id1615911539",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.spotit",
    icon: spotIt,
  },
  {
    id: 59,
    title: "Vehicle master",
    appleUrl: "https://apps.apple.com/us/app/vehicle-master/id1589907680",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.vehicle",
    icon: vehicleMaster,
  },
  {
    id: 58,
    title: "Tank ball",
    appleUrl: "https://apps.apple.com/us/app/tankball/id1593507763",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.tank",
    icon: tankBalls,
  },
  {
    id: 57,
    title: "Slide balls",
    appleUrl: "https://apps.apple.com/us/app/slide-balls/id1593512763",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.slideballs",
    icon: slideBalls,
  },
  {
    id: 56,
    title: "Flight.io",
    appleUrl: "https://apps.apple.com/us/app/flight-io/id1590964159",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.flight",
    icon: flightIO,
  },
  {
    id: 55,
    title: "Cut the paper",
    appleUrl: "https://apps.apple.com/us/app/cut-the-paper/id1594799159",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.cutit",
    icon: cutThePaper,
  },
  {
    id: 54,
    title: "Bomb brothers",
    appleUrl: "https://apps.apple.com/us/app/bomb-brothers/id1592634355",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.bomb",
    icon: bombBrothers,
  },

  {
    id: 53,
    title: "Climbing Fish 3D",
    appleUrl: "https://apps.apple.com/us/app/fish-out-of-water-3d/id1590258772",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.fish",
    icon: fishOutOfWater,
  },
  {
    id: 1,
    title: "#snapshot",
    appleUrl: "https://apps.apple.com/app/id1516411627",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.snapshot",
    icon: snapShot,
  },
  {
    id: 2,
    title: "Agent Twist",
    appleUrl: "https://apps.apple.com/app/id1558384576",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.twist",
    icon: agentTwist,
  },
  {
    id: 3,
    title: "Ants and Mantis",
    appleUrl: "https://apps.apple.com/us/app/id1553019808",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.ants",
    icon: antsAndMantis,
  },
  {
    id: 4,
    title: "Be a pong",
    appleUrl: "https://apps.apple.com/app/id1463354791",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.beerpong",
    icon: be_A_Pong,
  },
  {
    id: 5,
    title: "Cafe Master",
    appleUrl: "https://apps.apple.com/us/app/wacky-jelly/id1521223943",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.cafe",
    icon: cafeMaster,
  },
  {
    id: 6,
    title: "Change and Drop",
    appleUrl: "https://apps.apple.com/us/app/rescue-boat/id1575647531",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.drop",
    icon: changeAndDrop,
  },
  {
    id: 7,
    title: "Change the Body",
    appleUrl: "https://apps.apple.com/app/id1581706693",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.change",
    icon: changeTheBody,
  },
  {
    id: 8,
    title: "Dart Pop 3D",
    appleUrl: "https://apps.apple.com/us/app/idle-landmark/id1468090417",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.dartpop",
    icon: dartPop,
  },
  {
    id: 9,
    title: "Decalcomanie Gallery",
    appleUrl: "https://apps.apple.com/us/app/tiny-run-3d/id1494923122",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.decal",
    icon: decalcomanieGallery,
  },
  {
    id: 10,
    title: "Domino Village",
    appleUrl: "https://apps.apple.com/us/app/shooting-color/id1485533179",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.domino",
    icon: dominoVilage,
  },
  {
    id: 11,
    title: "Dumb turtle",
    appleUrl: "https://apps.apple.com/us/app/my-foodtruck-3d/id1545871788",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.turtle",
    icon: dumbTurtle,
  },
  {
    id: 12,
    title: "Egg drop 3D",
    appleUrl: "https://apps.apple.com/us/app/perfect-challenge/id1540925342",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.kitchen",
    icon: eggDrop,
  },
  {
    id: 13,
    title: "Fill Up Run",
    appleUrl: "https://apps.apple.com/us/app/sneak-out-3d/id1577896372",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.fill",
    icon: fillUpRun,
  },
  {
    id: 14,
    title: "Find Alien!",
    appleUrl: "https://apps.apple.com/us/app/ants-and-mantis/id1525172386",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.alien",
    icon: findAlien,
  },
  {
    id: 15,
    title: "Find Five 3D",
    appleUrl: "https://apps.apple.com/us/app/gentle-sniper/id1564691662",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.findfive",
    icon: findFive,
  },
  {
    id: 16,
    title: "Fireworks Castle",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1519168004",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.fireworks",
    icon: fireworksCastle,
  },
  {
    id: 17,
    title: "Flat Cube : 2D Cube Puzzle",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1448987738",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.flatcube",
    icon: flatCube,
  },
  {
    id: 18,
    title: "Gentle Sniper",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1449222715",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.gentlesniper",
    icon: gentle_Sniper,
  },
  {
    id: 19,
    title: "Gravity Rush 3D",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1580876517",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.hole",
    icon: gravityRush,
  },
  {
    id: 20,
    title: "Heroes Run",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1575320256",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.hero",
    icon: herosRun,
  },
  {
    id: 21,
    title: "Hydro Dipping!",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1501136001",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.liquidgame",
    icon: hydroDipping,
  },
  {
    id: 22,
    title: "Idle landmark!",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1540027861",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.build",
    icon: idleLandMark,
  },
  {
    id: 23,
    title: "IQ and R",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1531433506",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.iqandr",
    icon: iqAndR,
  },
  {
    id: 24,
    title: "Just Maze",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1455810999",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.justmaze",
    icon: justMaze,
  },
  {
    id: 25,
    title: "Kill the bug!",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1473225367",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.killthebug",
    icon: killTheBug,
  },
  {
    id: 26,
    title: "Life of Mellow",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1578810061",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.mellow",
    icon: lifeOfMellow,
  },
  {
    id: 27,
    title: "Light up my house!",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1529389452",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.light",
    icon: lightUpMyHouse,
  },
  {
    id: 28,
    title: "lit it",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1465066716",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.litit",
    icon: litIt,
  },
  {
    id: 29,
    title: "My Foodtruck 3D",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1556557149",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.foodtruck",
    icon: myFoodTruck,
  },
  {
    id: 30,
    title: "Number Run 3D",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1580683101",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.number",
    icon: numberRun,
  },
  {
    id: 31,
    title: "Orbit.io",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1449945304",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.orbit.io",
    icon: orbitIo,
  },
  {
    id: 32,
    title: "Perfect Challenge",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1564403170",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.perfect",
    icon: perfectChallenge,
  },
  {
    id: 33,
    title: "Prank Starz",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1523425849",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.frank",
    icon: prankStarz,
  },
  {
    id: 34,
    title: "Rescue Boat!",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1542900896",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.rescue",
    icon: rescueBoat,
  },
  {
    id: 35,
    title: "Rolling Queen",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1582944436",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.queen",
    icon: rollingQueen,
  },
  {
    id: 36,
    title: "Rooms N Looter",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1538530150",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.rooms",
    icon: roomsNLooter,
  },
  {
    id: 37,
    title: "Shooting Color",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1526783155",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.shootingcolor",
    icon: shootingColor,
  },
  {
    id: 38,
    title: "Sneak Out 3D",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1551261574",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.sneak",
    icon: sneak_Out,
  },
  {
    id: 39,
    title: "Space Core : The Ragnarok",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1560625528",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.space",
    icon: spaceCore,
  },
  {
    id: 40,
    title: "Splash Jump : Spring Board",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1448226899",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.splashjump",
    icon: splashJump,
  },
  {
    id: 41,
    title: "Stack Cube!",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1532187971",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.stack",
    icon: stackCube,
  },
  {
    id: 42,
    title: "Stack Runway 3D",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1562624460",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.runway",
    icon: stackRunway,
  },
  {
    id: 43,
    title: "Stack Rush 3D",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1560759666",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.stackrush",
    icon: stackRush,
  },
  {
    id: 44,
    title: "Sword hero!",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1544371009",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.swordhero",
    icon: swordHero,
  },
  {
    id: 45,
    title: "Time Stopper 3D",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1576478679",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.timestop",
    icon: timeStopper,
  },
  {
    id: 46,
    title: "Time Walker 3D",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1560768338",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.time",
    icon: timeWalker,
  },
  {
    id: 47,
    title: "Tiny Run 3D",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1565919001",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.tiny",
    icon: tinyRun,
  },
  {
    id: 48,
    title: "Trampoline King",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1585770708",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.trampoline",
    icon: trampolineKing,
  },
  {
    id: 49,
    title: "Wacky Jelly",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1566969578",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.jelly",
    icon: wacky_Jelly,
  },
  {
    id: 50,
    title: "Wash House 3D!",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1531043224",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.wash",
    icon: washHouse,
  },
  {
    id: 51,
    title: "Which is which",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1562102341",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.which",
    icon: whichIsWhich,
  },
  {
    id: 52,
    title: "ZScavenger",
    appleUrl: "https://apps.apple.com/us/app/stack-cube/id1544918247",
    googleUrl:
      "https://play.google.com/store/apps/details?id=com.mondayoff.zombie",
    icon: zScavenger,
  },
];
